import { useLocation, useNavigate } from 'react-router-dom';

import { useOrganizationParam } from '@packages/hooks/use-organization-param';

import { OrganizationSwitch } from '../../organizations/organizations-switch/organizations-switch';

export const OrganizationSwitcher = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const organizationId = useOrganizationParam();

  return (
    <OrganizationSwitch
      width={300}
      organization={organizationId}
      onOrganizationChange={(orgId) =>
        navigate(location.pathname.replace(organizationId, orgId))
      }
    />
  );
};
